import React from "react";
import { TableUi } from "../../../../ui/TableUi";
import { useDispatch } from "react-redux";
import {
  consolidadoTelaSetActive,
  get_pdf_consolidado_tela,
  get_pdf_programacion_tintoreria,
  programacionTintoreriaSetActive,
  programacionTintoreriaStartDelete,
  programacionTintoreriaStartLoad,
  showFormConsolidadoTela,
  showFormProgramacionTintoreria,
} from "../../../../../actions/produccion";
import { showDeleteConfirm } from "../../../../../helpers/confirmModal";
import {
  DeleteOutlined,
  DiffOutlined,
  EditOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";
import {
  open_pdf_file,
  parseDateFormatFrontEnd,
  parseNumeric,
} from "../../../../../helpers/utils";
import { EstadoProgramacionTag } from "../../reusable/EstadoProgramacionTag";
import { DropdownButtonUi } from "../../../../ui/DropdownButtonUi";
import { Space } from "antd";
import { messageError } from "../../../../../helpers/messageConfig";
const keys_actions = {
  editar: "editar",
  eliminar: "eliminar",
  consolidar: "consolidar",
};
const keys_reportes = {
  tintoreria: "pdf_tintoreria",
  consolidado: "pdf_consolidado",
};
let itemsActions = [
  {
    key: keys_actions.editar,
    label: "Editar",
    icon: <EditOutlined />,
  },
  {
    key: keys_actions.eliminar,
    label: "Eliminar",
    icon: <DeleteOutlined />,
  },
  {
    key: keys_actions.consolidar,
    label: "Consolidar tela",
    icon: <DiffOutlined />,
  },
];
const reportesActions = [
  {
    key: keys_reportes.tintoreria,
    label: "P.Tintoreria",
    icon: <FilePdfOutlined style={{ color: "#FF0000" }} />,
  },
  {
    key: keys_reportes.consolidado,
    label: "Consolidado Tela",
    icon: <FilePdfOutlined style={{ color: "#FF0000" }} />,
  },
];
const handleMenuClick = (e, record, acciones) => {
  const {
    handleEditar,
    handleEliminar,
    handleConsolidar,
    handlePDFProgramacionTintoreria,
    handlePDFConsolidadoTela,
  } = acciones;
  switch (e.key) {
    case "editar":
      handleEditar(record);
      break;
    case "eliminar":
      handleEliminar(record);
      break;
    case "consolidar":
      handleConsolidar(record);
      break;
    case "pdf_tintoreria":
      handlePDFProgramacionTintoreria(record);
      break;
    case "pdf_consolidado":
      handlePDFConsolidadoTela(record);
      break;
    default:
      break;
  }
};
const columns_table = (acciones) => {
  const {
    handleEditar,
    handleEliminar,
    handlePDFProgramacionTintoreria,
    handleConsolidar,
    handlePDFConsolidadoTela,
  } = acciones;
  return [
    {
      title: "#",
      dataIndex: "nro",
      key: "nro",
      align: "center",
      render: (text, record, index) => <>{index + 1}</>,
    },
    {
      title: "Fecha inicio",
      dataIndex: "fechainicio",
      key: "fechainicio",
      align: "center",
      render: (text) => <>{parseDateFormatFrontEnd(text)}</>,
    },
    {
      title: "Código",
      dataIndex: "codigo",
      key: "codigo",
      align: "center",
    },
    {
      title: "Proveedor",
      dataIndex: "proveedor_nombre",
      key: "proveedor_nombre",
      align: "center",
      render: (text, record) => (
        <>
          {text}
          <h5 style={{ margin: 0 }}>{record?.proveedor_ruc}</h5>
        </>
      ),
    },
    {
      title: (
        <>
          <span>Cantidad</span> <br /> <sub>(Rollos, Cuello,etc)</sub>
        </>
      ),
      dataIndex: "cantidadrollostotal",
      key: "cantidadrollostotal",
      align: "center",
    },
    {
      title: (
        <>
          <span>Peso bruto</span> <br /> <sub>(KG)</sub>
        </>
      ),
      dataIndex: "pesobrutototal",
      key: "pesobrutototal",
      align: "center",
    },
    {
      title: (
        <>
          <span>Peso neto</span> <br /> <sub>(KG)</sub>
        </>
      ),
      dataIndex: "pesonetototal",
      key: "pesonetototal",
      align: "center",
    },
    {
      title: "Merma",
      dataIndex: "merma",
      key: "merma",
      align: "center",
      render: (text, record) => (
        <>
          {parseNumeric(record?.pesobrutototal - record?.pesonetototal) + " KG"}
          <h5 style={{ margin: 0 }}>
            {parseNumeric(
              (parseNumeric(record?.pesobrutototal - record?.pesonetototal) /
                parseNumeric(record?.pesobrutototal)) *
                100
            ) + "%"}
          </h5>
        </>
      ),
    },
    {
      title: "Estado",
      dataIndex: "nombreestado",
      key: "nombreestado",
      render: (text, record) => (
        <EstadoProgramacionTag estado={record?.estado} estado_nombre={text} />
      ),
    },
    {
      title: "",
      dataIndex: "acciones",
      key: "acciones",
      render: (text, record) => {
        let accionesFilter = [];
        let reportesActivos = [];
        if (record?.consolidadotela) {
          accionesFilter = itemsActions.filter(
            (x) => x.key !== keys_actions.eliminar
          );
          reportesActivos = reportesActions;
        } else {
          accionesFilter = itemsActions;
          reportesActivos = reportesActions.filter(
            (x) => x.key !== keys_reportes.consolidado
          );
        }
        return (
          <Space>
            <DropdownButtonUi
              items={accionesFilter}
              handleItemClick={(e) =>
                handleMenuClick(e, record, {
                  handleEditar,
                  handleEliminar,
                  handleConsolidar,
                })
              }
            />
            <DropdownButtonUi
              items={reportesActivos}
              label="Reportes"
              handleItemClick={(e) =>
                handleMenuClick(e, record, {
                  handlePDFProgramacionTintoreria,
                  handlePDFConsolidadoTela,
                })
              }
            />
          </Space>
        );
      },
    },
  ];
};
export const ProgramacionTintoreriaTable = ({ data, loading, paginator }) => {
  const dispatch = useDispatch();
  const handleEditar = (programaciontejido) => {
    dispatch(programacionTintoreriaSetActive(programaciontejido));
    dispatch(showFormProgramacionTintoreria());
  };
  const handleEliminar = (programacion) => {
    showDeleteConfirm(
      "¿Está seguro de eliminar la programación de tintoreria?",
      `${programacion.proveedor_nombre} - ${programacion.cantidadrollostotal} rollos`,
      (isConfirmed) => {
        if (isConfirmed) {
          dispatch(programacionTintoreriaStartDelete(programacion));
        }
      }
    );
  };
  const handleConsolidar = (row) => {
    dispatch(
      consolidadoTelaSetActive({
        ...row?.consolidadotela,
        proveedor_nombre: row?.proveedor_nombre,
        proveedor_ruc: row?.proveedor_ruc,
        codigo: row?.codigo,
        fechatintoreria: row?.fechainicio,
        programaciontintoreria: row?.id,
      })
    );
    dispatch(showFormConsolidadoTela());
  };
  const handlePDFProgramacionTintoreria = async (programacion) => {
    const file = await get_pdf_programacion_tintoreria(programacion?.id);
    let name_file = `${programacion.proveedor_ruc}-${programacion?.codigo}.pdf`;
    open_pdf_file(file, name_file);
  };
  const handlePDFConsolidadoTela = async (programacion) => {
    if (programacion?.consolidadotela?.id) {
      const file = await get_pdf_consolidado_tela(
        programacion?.consolidadotela?.id
      );
      let name_file = `Consolidado-${programacion?.codigo}.pdf`;
      open_pdf_file(file, name_file);
    } else
      messageError(
        "La programación de tintoreria no se ha sido consolidado!!!"
      );
  };

  const handleLoadData = (page = 1, page_size = 10) => {
    let searchFormData = JSON.parse(localStorage.getItem("SearhFormTable"));
    searchFormData = { ...searchFormData, page, page_size };
    dispatch(programacionTintoreriaStartLoad(searchFormData));
  };
  return (
    <TableUi
      columns={columns_table({
        handleEditar,
        handleEliminar,
        handleConsolidar,
        handlePDFProgramacionTintoreria,
        handlePDFConsolidadoTela,
      })}
      rowKey="id"
      dataSource={data}
      size="small"
      loading={loading}
      pagination={{
        align: "start",
        showSizeChanger: true,
        total: paginator?.count,
        onChange: (page, page_size) => handleLoadData(page, page_size),
        showTotal: (total) => `Total ${total} items`,
      }}
    />
  );
};
